/**
 * <biosphere-reading-progress> — how far through the article the reader is.
 *
 * Decorative: rendered hidden, revealed here, and aria-hidden, since the
 * scrollbar already reports it. Set on a scroll listener because scroll-driven
 * animations are below this theme's browser floor; reads batch into a frame.
 */
if (!customElements.get("biosphere-reading-progress")) {
  customElements.define(
    "biosphere-reading-progress",
    class BiosphereReadingProgress extends HTMLElement {
      #controller = new AbortController();
      #bar = null;
      #frame = 0;

      connectedCallback() {
        this.#bar = this.querySelector(".biosphere-reading-progress__bar");
        if (!this.#bar) return;

        this.setAttribute("aria-hidden", "true");
        const { signal } = this.#controller;
        addEventListener("scroll", () => this.#schedule(), {
          passive: true,
          signal,
        });
        addEventListener("resize", () => this.#schedule(), {
          passive: true,
          signal,
        });

        this.hidden = false;
        this.#update();
      }

      disconnectedCallback() {
        this.#controller.abort();
        cancelAnimationFrame(this.#frame);
      }

      #schedule() {
        cancelAnimationFrame(this.#frame);
        this.#frame = requestAnimationFrame(() => this.#update());
      }

      #update() {
        const scrollable = document.documentElement.scrollHeight - innerHeight;
        // A page shorter than the viewport has nothing to report.
        const progress =
          scrollable > 0 ? Math.min(1, Math.max(0, scrollY / scrollable)) : 0;
        this.#bar.style.transform = `scaleX(${progress})`;
      }
    },
  );
}
